import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { FDBox, FDSearchInput, FDStack } from '@facet-wealth/design';
import CollectionQueryForm from 'Components/ComponentLibrary/Molecules/CollectionQueryForm';
import fr from 'facet-rest';
import TemplateOptionsQueryLayout from 'Components/UI/TemplateOptionsMenu/TemplateOptionsQueryLayout';
import { buildFacetDesignFilterFormOverride } from 'Packages/FacetRest/FacetDesignFilterFormOverride';
import Skeleton from '@material-ui/lab/Skeleton';
import { dataAttrs } from 'Helpers/Testing';

export const TemplateMetaOverrideSet = buildFacetDesignFilterFormOverride()
  .typeOverride('picklist', {
    _customProps: {
      fullWidth: true,
    },
  });

const styles = theme => ({
  root: {
    padding: theme.spacing(0, 1, 1.5),
    borderBottom: `1px solid ${theme.palette.facet.lightGray}`,
  },
});

const TemplateOptionsSearchInput = ({
  className,
  classes,
  searchTemplates,
  templateCollection,
  setTemplateCollection,
  setAllTemplatesCurrentPageNumber,
}) => {
  const [searchValue, setSearchValue] = useState('');

  // Handle Search Input change
  const handleSearchTemplates = (event) => {
    setSearchValue(event.target.value);
    searchTemplates(event.target.value);
  };

  /* TODO: remove minHeight
  * fix - minHeight added to FDStack
  * since templateCollection is always defined, skeleton does not render;
  * because of this, the initial render size of the FDStack is too small.
  * The element anchor is calculated prior to FDStack render and is then
  * pushed down below fold when FDStack fully renders. MinHeight is a
  * VERY ugly patch-fix, but until we can get an accurate isLoading
  * state out of FDStack, may be the only solution.
  */
  return (
    <div
      className={classNames(classes.root, className)}
    >
      <FDStack direction={'column'} minHeight={100}>
        {templateCollection ? (
          <CollectionQueryForm
            collection={templateCollection}
            layout={TemplateOptionsQueryLayout}
            metaOverrideSet={TemplateMetaOverrideSet}
            onSubmit={(searchResultCollection) => {
              setAllTemplatesCurrentPageNumber(1);
              setTemplateCollection(searchResultCollection);
            }}
          />
        ) : (
          <FDBox paddingX={2} paddingY={1}>
            <Skeleton variant="rect" width={'100%'} height={55} />
          </FDBox>)}
        <FDBox paddingX={2}>
          <FDSearchInput
            {...dataAttrs('template-search-bar-input')}
            placeholder={'Search templates'}
            value={searchValue}
            onChange={handleSearchTemplates}
            onSearch={handleSearchTemplates}
            fullWidth
          />
        </FDBox>
      </FDStack>
    </div>
  );
};

TemplateOptionsSearchInput.defaultProps = {
  className: '',
};

TemplateOptionsSearchInput.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  searchTemplates: PropTypes.func.isRequired,
  templateCollection: PropTypes.instanceOf(fr.Collection).isRequired,
  setTemplateCollection: PropTypes.func.isRequired,
  setAllTemplatesCurrentPageNumber: PropTypes.func.isRequired,
};

export default withStyles(styles)(TemplateOptionsSearchInput);
